import React, { useEffect, useState } from 'react'
import { fetchPackageCategory } from '../utils/services'
import { useSelector } from 'react-redux';

const useFetchPackageCategory = () => {
    const [categoryData, setCategoryData] = useState([])
    const culture = useSelector((state) => state.culture.currentCulture);
    const currency = useSelector((state) => state.currencyDetails);
    useEffect(() => {
        (async () => {
            if (!currency.loading) {
                let packageResult = await fetchPackageCategory(culture, currency.currentCurrency)
                if (packageResult) {
                    setCategoryData(packageResult)
                }
            }
        })()
    }, [currency])
    return { categoryData }
}

export default useFetchPackageCategory